export default __webpack_public_path__ + "static/media/photo-2.698efbc4.jpg";